var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t(
                    "BusinessIntelligence.businessIntelligenceChartTab"
                  ),
                  name: "businessIntelligenceChart",
                  lazy: true
                }
              },
              [
                _c("business-Intelligence-Chart", {
                  ref: "businessIntelligenceChart"
                })
              ],
              1
            ),
            _vm.$checkPermission(["role_biConfig_toView"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t(
                        "BusinessIntelligence.businessIntelligenceDashboardTab"
                      ),
                      name: "businessIntelligenceDashboard",
                      lazy: true
                    }
                  },
                  [
                    _c("business-Intelligence-Dashboard", {
                      attrs: { entrance: _vm.entrance }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("BusinessIntelligence.chartGroupSettingTab"),
                  name: "chartGroupSetting",
                  lazy: true
                }
              },
              [_c("chart-Group-Setting", { ref: "chartGroupSetting" })],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }